/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_ActionInputs */

const cs_client_merge_action = /** @type {(inputs: Client_Merge_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sloučit do…`)
};

const en_client_merge_action = /** @type {(inputs: Client_Merge_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge into…`)
};

/**
* | output |
* | --- |
* | "Merge into…" |
*
* @param {Client_Merge_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_action = /** @type {((inputs?: Client_Merge_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_action(inputs)
	return cs_client_merge_action(inputs)
});